import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b4eaa66c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "checkout-items" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "checkout-items-title" }, " Your order ", -1))
const _hoisted_3 = { class: "checkout-items-line" }
const _hoisted_4 = { class: "checkout-items-line-top" }
const _hoisted_5 = {
  key: 0,
  class: "loading-container"
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "checkout-items-line" }
const _hoisted_8 = { class: "checkout-items-line-top" }
const _hoisted_9 = { class: "checkout-item-with-tooltip" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Manifold Fee", -1))
const _hoisted_11 = {
  key: 0,
  class: "loading-container"
}
const _hoisted_12 = { key: 1 }
const _hoisted_13 = {
  key: 0,
  class: "checkout-items-line"
}
const _hoisted_14 = { class: "checkout-items-line-top" }
const _hoisted_15 = { class: "checkout-item-with-tooltip" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Processing Fees", -1))
const _hoisted_17 = {
  key: 0,
  class: "loading-container"
}
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "checkout-items-line" }
const _hoisted_20 = { class: "checkout-items-line-top checkout-items-line-total" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Total", -1))
const _hoisted_22 = {
  key: 0,
  class: "loading-container"
}
const _hoisted_23 = { key: 1 }

import { BigNumber } from '@ethersproject/bignumber';
import { computed } from 'vue';
import { MANIFOLD_FEE_EXPLANATION, PROCESSING_FEES_EXPLANATION } from '@/common/constants';
import Tooltip from '@/components/Tooltip.vue';
import { formatUSDCentsToDollars } from '@/lib/currency';

interface CheckoutItemsForCardProps {
  numberToMint: number;
  itemPrice: BigNumber;
  manifoldFee: BigNumber;
  processingFees: BigNumber;
  totalCost: BigNumber;
  loadingPrices: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutItemsForCard',
  props: {
    numberToMint: null,
    itemPrice: null,
    manifoldFee: null,
    processingFees: null,
    totalCost: null,
    loadingPrices: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  numberToMint: number;
  itemPrice: BigNumber;
  manifoldFee: BigNumber;
  processingFees: BigNumber;
  totalCost: BigNumber;
  loadingPrices: boolean;
};



const itemPriceString = computed(() => {
  return formatUSDCentsToDollars(props.itemPrice);
});

const manifoldFeeString = computed(() => {
  return formatUSDCentsToDollars(props.manifoldFee);
});

const processingFeesString = computed(() => {
  return formatUSDCentsToDollars(props.processingFees);
});

const hasProcessingFees = computed(() => {
  return props.processingFees.gt(0);
});

const totalCostString = computed(() => {
  return formatUSDCentsToDollars(props.totalCost);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", null, "Item x " + _toDisplayString(__props.numberToMint), 1),
        (__props.loadingPrices)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5))
          : (_openBlock(), _createElementBlock("span", _hoisted_6, "$" + _toDisplayString(_unref(itemPriceString)), 1))
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createVNode(Tooltip, {
            header: "Manifold Fee",
            content: _unref(MANIFOLD_FEE_EXPLANATION)
          }, null, 8, ["content"])
        ]),
        (__props.loadingPrices)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11))
          : (_openBlock(), _createElementBlock("span", _hoisted_12, "$" + _toDisplayString(_unref(manifoldFeeString)), 1))
      ])
    ]),
    (_unref(hasProcessingFees))
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createVNode(Tooltip, {
                header: "Processing Fees",
                content: _unref(PROCESSING_FEES_EXPLANATION)
              }, null, 8, ["content"])
            ]),
            (__props.loadingPrices)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17))
              : (_openBlock(), _createElementBlock("span", _hoisted_18, "$" + _toDisplayString(_unref(processingFeesString)), 1))
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _hoisted_21,
        (__props.loadingPrices)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22))
          : (_openBlock(), _createElementBlock("span", _hoisted_23, "$" + _toDisplayString(_unref(totalCostString)), 1))
      ])
    ])
  ]))
}
}

})